import { Directive, HostListener, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { MOBILE_BRIDGE_EVENT_RECEIVE, MOBILE_BRIDGE_EVENT_SEND, type imagePickerProps } from '@constants/mobile-bridge.constant';
import { MobileBridgeService } from '@services/mobile-bridge.service';

@Directive({
  selector: '[appMobileBridgeFileInput]',
  standalone: true
})
export class MobileBridgeFileInputDirective {
  @Input() fileConfig: imagePickerProps = null;
  @Output() mobileFileChange = new EventEmitter();

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private mobileBridgeService: MobileBridgeService
  ) { }

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    const messageType = this.fileConfig?.messageType
      ?? (
        this.el.nativeElement?.accept?.toLowerCase().includes('.mp4')
          ? MOBILE_BRIDGE_EVENT_SEND.NATIVE_VIDEO_PICKER
          : MOBILE_BRIDGE_EVENT_SEND.NATIVE_IMAGE_PICKER
      );

    if (this.mobileBridgeService.isMobileApp) {
      if (messageType === MOBILE_BRIDGE_EVENT_SEND.ALL_MEDIA_PICKER) {
        if (!this.mobileBridgeService.permissions.allFilesPicker) {
          event.preventDefault();
          this.mobileBridgeService.sendMessage(messageType, {
            accept: this.el.nativeElement.accept || ''
          });

          this.mobileBridgeService.messageSubject.subscribe(message => {
            if (message.type === MOBILE_BRIDGE_EVENT_RECEIVE.SET_ALL_MEDIA_PICKER && message.payload) {
              if (message.payload.success) {
                this.mobileBridgeService.permissions.allFilesPicker = true;
                this.mobileBridgeService.permissions.imageVideoPicker = true;
              }
            }
          });
        }
      } else if (messageType === MOBILE_BRIDGE_EVENT_SEND.IMAGE_VIDEO_PICKER) {
        if (!this.mobileBridgeService.permissions.imageVideoPicker) {
          event.preventDefault();
          this.mobileBridgeService.sendMessage(messageType, {
            accept: this.el.nativeElement.accept || ''
          });

          this.mobileBridgeService.messageSubject.subscribe(message => {
            if (message.type === MOBILE_BRIDGE_EVENT_RECEIVE.SET_IMAGE_VIDEO_PICKER && message.payload) {
              if (message.payload.success) {
                this.mobileBridgeService.permissions.imageVideoPicker = true;
              }
            }
          });
        }
      } else if (messageType === MOBILE_BRIDGE_EVENT_SEND.NATIVE_IMAGE_PICKER) {
        event.preventDefault();
        this.mobileBridgeService.messageSubject.subscribe(message => {
          if (message.type === MOBILE_BRIDGE_EVENT_RECEIVE.SET_IMAGE_UPLOAD && message.payload?.files?.length) {
            if (message.payload.imageType) {
              this.mobileFileChange.emit({
                imageType: message.payload.imageType,
                files: message.payload.files
              });
            } else {
              this.mobileFileChange.emit(message.payload.files);
            }
          }
        });

        this.mobileBridgeService.sendMessage(messageType, {
          accept: this.el.nativeElement.accept || '',
          ...this.fileConfig,
        });
      } else if (messageType === MOBILE_BRIDGE_EVENT_SEND.NATIVE_VIDEO_PICKER) {
        if (!this.mobileBridgeService.permissions.imageVideoPicker) {
          event.preventDefault();
          this.mobileBridgeService.sendMessage(messageType, {
            accept: this.el.nativeElement.accept || ''
          });

          this.mobileBridgeService.messageSubject.subscribe(message => {
            if (message.type === MOBILE_BRIDGE_EVENT_RECEIVE.SET_VIDEO_UPLOAD && message.payload) {
              if (message.payload.success) {
                this.mobileBridgeService.permissions.imageVideoPicker = true;
              }
            }
          });
        }
      }
    }
  }
}